import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

// Owns the deterministic verification and delivery end of the compound flow.
export function CompoundAiVerificationStage() {
  return (
    <>
      <DiagramNode
        x={180}
        y={298}
        width={340}
        height={48}
        label="Compliance & Rule Guardrails"
        sublabel="Deterministic Regex, SLA & Policy Checks"
        variant="brass"
      />
      <path
        d="M 350 346 L 350 380"
        fill="none"
        stroke="#10b981"
        strokeWidth="1.8"
        markerEnd="url(#ca-arrow-green)"
      />
      <DiagramNode
        x={200}
        y={382}
        width={300}
        height={48}
        label="Verified Execution Output"
        sublabel="Policy Validated & Audit Logged"
        variant="success"
      />
    </>
  );
}
